<template>
  <BLayoutList
    :title="pageTitle"
    :skeleton="isLoadingAsyncData"
  >
    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="procedures"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:open-modal="onOpenModal"
    />
  </BLayoutList>
</template>

<script>
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { ProcedureModel as Model } from './Model'
import { ProceduresStoreModule as StoreModule } from './store'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from './components/PublicationsFilter.vue'
import { createProcedureModal } from './utils'
import { dateFormatter } from "@/helpers/dateFormatter";

const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ProceduresList',
  components: {
    BLayoutList,
    BTableCommon,
    ComponentFilter,
  },
  mixins: [listMixin],
  methods: {
    async onOpenModal(data) {
    const propsData = {
        procedure_name: data.name,
        procedure_id: data.procedure_id,
        scan_start_at: dateFormatter(data.scan_start_at, "YYYY-MM-DDTHH:mm:ssZ"),
        scan_end_at: dateFormatter(data.scan_end_at, "YYYY-MM-DDTHH:mm:ssZ"),
        is_scan_incomplete_sets_allowed: data.is_scan_incomplete_sets_allowed
      }
      const modal = await createProcedureModal(this, propsData)
      await modal.open()
      modal.$on('saved', this.onUpdateWithRefresh())
    },
  },
}
</script>
